import { ref } from 'vue'

export function useMfa() {
  const stepError = ref('')

  const extractFieldError = (error, field) => {
    const errors = error.response?.data?.errors
    const messages = errors?.[field]

    if (!messages) return ''

    return Array.isArray(messages) ? messages[0] : String(messages)
  }

  const extractFirstError = (error, fallback = 'Something went wrong. Please try again.') => {
    if (error.response?.status === 429) {
      return error.response?.data?.message ?? 'Too many attempts. Please try again later.'
    }

    const message = error.response?.data?.message
    if (message && !error.response?.data?.errors) {
      return message
    }

    const errors = error.response?.data?.errors
    if (!errors) return fallback
    const messages = Object.values(errors)[0]
    return Array.isArray(messages) ? (messages[0] || fallback) : String(messages || fallback)
  }

  const extractError = (error, field, fallback = 'Something went wrong. Please try again.') => (
    extractFieldError(error, field) || extractFirstError(error, fallback)
  )

  const setError = (message) => {
    stepError.value = message
  }

  const clearError = () => {
    stepError.value = ''
  }

  return {
    stepError,
    extractError,
    extractFieldError,
    extractFirstError,
    setError,
    clearError,
  }
}
